const isMatchingPlan = (planName: string, matchingPlans: string[]): boolean => {
  return matchingPlans.some((matchingPlan) => planName.includes(matchingPlan));
};

const spectrumFreeWithInternetPlans = ['Internet Gig'];
const spectrumFreeWithTvBundlePlans = [
  'Internet Advantage',
  'Internet Premier',
];

export const getEquipmentRentalText = (
  planName: string,
  providerCode: string,
  tvBundled: boolean
): string | null => {
  if (providerCode === 'spectrum') {
    if (isMatchingPlan(planName, spectrumFreeWithInternetPlans)) {
      return 'Free modem + router rental';
    } else if (
      tvBundled &&
      isMatchingPlan(planName, spectrumFreeWithTvBundlePlans)
    ) {
      return 'Free modem + router rental with bundle';
    }
  }

  return null;
};
